import { nanoid } from "nanoid";
import { useState } from "react";
import NewComment from "./NewComment";
import Reply from "./Reply";
import deleteIcon from '../images/icon-delete.svg'
import editIcon from '../images/icon-edit.svg'
import replyIcon from '../images/icon-reply.svg'


export default function Comment(props) {
    const [backendReplies, setBackendReplies] = useState(props.replies);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const isCurrentUser = props.user.username === props.currentUser.username;
    const isReplying =
        props.activeComment &&
        props.activeComment.id === props.id &&
        props.activeComment.type === "replying";
    const isEditing =
        props.activeComment &&
        props.activeComment.id === props.id &&
        props.activeComment.type === "editing";

    const createReply = async (text) => {
        return {
            content: text,
            createdAt: "Recém Criado",
            id: nanoid(),
            replyingTo: props.user.username,
            user: props.currentUser,
        };
    };

    const addReply = (text) => {
        createReply(text).then((reply) => {
            setBackendReplies([reply, ...backendReplies]);
        });
        props.setActiveComment(null);
    };

    const deleteReply = (replyId) => {
        for (let i = 0; i < backendReplies.length; i++) {
            const updatedBackendReplies = backendReplies.filter(
                (backendReply) => backendReply.id !== replyId
            );
            setBackendReplies(updatedBackendReplies);
        }
    };

    const updateReply = (text, replyId) => {
        const updatedBackendReplies = backendReplies.map((backendReply) => {
            if (backendReply.id === replyId) {
                return { ...backendReply, content: text }
            }
            return backendReply
        })
        setBackendReplies(updatedBackendReplies)
        props.setActiveComment(null)
    }

    return (
        <div className="comment-container">
            <div className="comment">
                <div className="comment-heading">
                    <img
                        className="user-avatar"
                        src={props.user.image.png}
                        alt="user avatar"
                    />
                    <p className="username">{props.user.username}</p>
                    {props.user.username === props.currentUser.username && (
                        <p className="tag">Eu</p>
                    )}
                    <p className="date">{props.createdAt}</p>
                    <div className="comment-footer">
                        {isCurrentUser ? (
                            <div className="toggled-btns">
                                <button
                                    className="edit-btn"
                                    onClick={() => {
                                        props.setActiveComment({ id: props.id, type: "editing" });
                                    }}
                                >
                                    <img
                                        className="edit-icon"
                                        src={editIcon}
                                        alt="edit icon"
                                    />
                                    Editar
                                </button>
                                <button
                                    className="delete-btn"
                                    onClick={() => {
                                        setShowDeleteModal(true);
                                    }}
                                >
                                    <img
                                        className="delete-icon"
                                        src={deleteIcon}
                                        alt="delete icon"
                                    />
                                    Deletar
                                </button>
                            </div>
                        ) : (
                            <button
                                className="reply-btn"
                                onClick={() =>
                                    props.setActiveComment({ id: props.id, type: "replying" })
                                }
                            >
                                <img
                                    className="reply-icon"
                                    src={replyIcon}
                                    alt="reply icon"
                                />
                                Comentar
                            </button>
                        )}
                    </div>
                </div>
                <div className="editing">
                    {!isEditing && <p className="comment-content">{props.content}</p>}
                    {isEditing && (
                        <NewComment
                            currentUser={props.currentUser}
                            handleSubmit={(text) => {
                                props.updateComment(text, props.id);
                            }}
                            initialText={props.content}
                            isEdit
                            buttonText='Atualizar'
                        />
                    )}
                </div>
            </div>
            {isReplying && (
                <div>
                    <NewComment
                        currentUser={props.currentUser}
                        placeholder={`Respondendo para @${props.user.username}`}
                        handleSubmit={(text) =>
                            addReply(`@${props.user.username}, ${text}`)
                        }
                        buttonText='Enviar'
                    />
                </div>
            )}
            {props.replies && (
                <div className="replies-container">
                    {backendReplies.map((reply) => (
                        <div className="reply">
                            <Reply
                                key={reply.id}
                                currentUser={props.currentUser}
                                activeComment={props.activeComment}
                                setActiveComment={props.setActiveComment}
                                addReply={addReply}
                                deleteReply={deleteReply}
                                updateReply={updateReply}
                                {...reply}
                            />
                        </div>
                    ))}
                </div>
            )}
            {showDeleteModal && (
                <div className="delete-modal-container">
                    <div className="delete-modal">
                        <h2 className="delete-modal_title">Deletar comentário</h2>
                        <p className="delete-modal_content">
                            Você tem certeza que deseja deletar este comentário? Ele será removido
                            e não poderá ser desfeito.
                        </p>
                        <div className="delete-modal_btns">
                            <button
                                className="delete-modal_btn no"
                                onClick={() => {
                                    setShowDeleteModal(false);
                                }}
                            >
                                Não, cancelar
                            </button>
                            <button
                                className="delete-modal_btn yes"
                                onClick={() => {
                                    props.deleteComment(props.id);
                                }}
                            >
                                Sim, deletar
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}
